"use client";
import React, { useEffect } from "react";
import { analytics } from "lib/segment";

export const BlogTrackers = ({ blogData, slug }) => {
  useEffect(() => {
    if (
      blogData &&
      typeof window !== "undefined" &&
      (window.OnetrustActiveGroups == undefined ||
        window.OnetrustActiveGroups?.includes("2"))
    ) {
      analytics.track("Blog Page Visit", {
        author:
          blogData?.blog_authors.data.map((a) => a.attributes.Name) ||
          "Error fetching author(s)",
        publishedDate: blogData?.publishDate || "Error fetching date",
        title: blogData?.title || "Error fetching title",
        url: `/blog/${slug}` || "Error fetching url",
      });
    }
  }, []);
  return <></>;
};
